import { getImageFromS3 } from '../../../imageService';

export const challengeComponent = [
  {
    id: 'guess-city',
    title: (
      <>
        Вгадай місто
        <br />
        за фото
      </>
    ),
    description:
      'Наскільки добре ти знаєш Україну?\n' +
      'Давай перевіримо, чи зможеш ти\n' +
      'впізнати місто за одним фото?',
    // Reused blue ring icon (same asset the current LM challenges use).
    welcomeBackgroundIcon: getImageFromS3(
      '/images/taste-experimenter-challenge/welcome-background-icon.png'
    ),
    backgroundImage: getImageFromS3('/images/guess-city-challenge/bg.png'),
    startButtonTitle: 'До гри!',
    questions: [
      {
        id: 1,
        title: 'Яке місто зображене\nна фото?',
        image: getImageFromS3('/images/guess-city-challenge/1.png'),
        correctText: 'Правильно! Це Харків.',
        wrongText: 'Ні. На фото — Харків.',
        description:
          'Місто широких проспектів і сміливої архітектури. Відоме площею Свободи, конструктивізмом і характером, що не здається.',
        answerList: [
          { id: 1.1, title: 'Харків', isCorrect: true },
          { id: 1.2, title: 'Київ', isCorrect: false },
          { id: 1.3, title: 'Тернопіль', isCorrect: false }
        ]
      },
      {
        id: 2,
        title: 'Чиї краєвиди\nна світлині?',
        image: getImageFromS3('/images/guess-city-challenge/2.png'),
        correctText: 'Так! Це Дніпро.',
        wrongText: 'Ось і ні. На фото — Дніпро.',
        description:
          'Місто індустрії й космосу, де широкий Дніпро задає масштаб усьому навколо.',
        answerList: [
          { id: 2.1, title: 'Хмельницький', isCorrect: false },
          { id: 2.2, title: 'Дніпро', isCorrect: true },
          { id: 2.3, title: 'Умань', isCorrect: false }
        ]
      },
      {
        id: 3,
        title: 'А тут вдалось\nпобувати?',
        image: getImageFromS3('/images/guess-city-challenge/3.png'),
        correctText: 'О так! Це Івано-Франківськ.',
        wrongText: 'О ні. На фото —  Івано-Франківськ.',
        description:
          'Місто з атмосферою старих кам’яниць, двориків і площ. Неквапливий ритм дозволяє насолоджуватись життям на повну.',
        answerList: [
          { id: 4.1, title: 'Черкаси', isCorrect: false },
          { id: 4.2, title: 'Івано-Франківськ', isCorrect: true },
          { id: 4.3, title: 'Полтава', isCorrect: false }
        ]
      },
      {
        id: 4,
        title: 'Щось дуже знайоме,\nчи не так?',
        image: getImageFromS3('/images/guess-city-challenge/4.png'),
        correctText: 'Точно! Це Луцьк.',
        wrongText: 'Насправді на фото — Луцьк.',
        description:
          'Стародавнє місто Волині, відоме замком Любарта і вузькими вуличками історичного центру.',
        answerList: [
          { id: 3.1, title: 'Луцьк', isCorrect: true },
          { id: 3.2, title: 'Чернігів', isCorrect: false },
          { id: 3.3, title: 'Кривий Ріг', isCorrect: false }
        ]
      },
      {
        id: 5,
        title: 'А це що?',
        image: getImageFromS3('/images/guess-city-challenge/5.png'),
        correctText: 'Так! Це Київ.',
        wrongText: 'Ось і ні. На фото — Київ.',
        description:
          'Столиця України — місто пагорбів, золотих куполів і вулиць, де історія відчувається на кожному кроці.',
        answerList: [
          { id: 5.1, title: 'Одеса', isCorrect: false },
          { id: 5.2, title: 'Київ', isCorrect: true },
          { id: 5.3, title: 'Кропивницький', isCorrect: false }
        ]
      }
    ],
    // Order matters: [0] = <=3 correct, [1] = 4 correct, [2] = all correct.
    resultList: [
      {
        id: 1,
        title: 'Результат',
        subtitle: 'Попереду ще багато нових відкриттів!',
        description: 'Твоя карта світу тільки починає заповнюватися.',
        image: getImageFromS3('/images/guess-city-challenge/result3.png')
      },
      {
        id: 2,
        title: 'Результат',
        subtitle: 'Твоє мандрівне чуття — на впевнену четвірку.',
        description:
          'Деякі міста ти вгадуєш інтуїтивно, інші — плутаються між собою (так буває навіть у тревел-блогерів).',
        image: getImageFromS3('/images/guess-city-challenge/result2.png')
      },
      {
        id: 3,
        title: 'Результат',
        subtitle: 'Ти — справжній містоексперт.',
        description:
          'Впізнаєш світи за однією деталлю: дахом, пальмою чи навіть відтінком неба.',
        image: getImageFromS3('/images/guess-city-challenge/result1.png')
      }
    ],
    afterResultContent: {
      title: 'Ну як тобі тест?',
      description: 'Маємо надію, що ти відкрив\nдля себе багато цікавого!',
      image: getImageFromS3('/images/guess-city-challenge/after-result.png'),
      nextButtonText: 'Далі'
    }
  }
];
